import { render, staticRenderFns } from "./Site-header.vue?vue&type=template&id=ba8b51fc&scoped=true&"
import script from "./Site-header.vue?vue&type=script&lang=js&"
export * from "./Site-header.vue?vue&type=script&lang=js&"
import style0 from "./Site-header.vue?vue&type=style&index=0&id=ba8b51fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b51fc",
  null
  
)

export default component.exports